import {AthletePropositionBetModuleConfig} from "./athlete-proposition-bet-module.config";
import {AthletePropositionBetModuleStore} from "./athlete-proposition-bet-module.store";
import {AthletePropositionBetModuleHandlers} from "./handlers/athlete-proposition-bet-module.handlers";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {ModuleController} from "../../infrastructure/controllers/module-controller";

export class AthletePropositionBetModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, AthletePropositionBetModuleConfig, AthletePropositionBetModuleStore, AthletePropositionBetModuleHandlers];
}
